import { render, staticRenderFns } from "./ReportsClientMenu.vue?vue&type=template&id=3de60eae&"
import script from "./ReportsClientMenu.vue?vue&type=script&lang=js&"
export * from "./ReportsClientMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports